import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { gsm: () => import('./GsmLinesPage.vue') },
} satisfies FeatureRoutes
